export const PASSWORD_POLICY_DESCRIPTION =
  "Min 8 chars, at least 2 of: uppercase, lowercase, number, special character";

export const getPasswordPolicyErrors = (password: string): string[] => {
  const errors: string[] = [];

  if (password.length < 8) {
    errors.push("Use at least 8 characters.");
  }

  const categoryCount = [
    /[A-Z]/.test(password),
    /[a-z]/.test(password),
    /\d/.test(password),
    /[^A-Za-z0-9]/.test(password),
  ].filter(Boolean).length;

  if (categoryCount < 2) {
    errors.push(
      "Use at least 2 of uppercase, lowercase, number, special character."
    );
  }

  return errors;
};

export const isPasswordValid = (password: string) =>
  getPasswordPolicyErrors(password).length === 0;
